import { createIcon } from '../../createIcon';
import { withIcon } from '../../withIcon';
import { CalendarGridSvg } from './CalendarGrid';

export const CalendarGridIcon = createIcon('calendarGrid', CalendarGridSvg);
/**
 * @deprecated используйте CalendarGridIcon
 */
export const withCalendarGridIcon = withIcon('calendarGrid', CalendarGridSvg);
